import config from '@/constant.js'

const auth = {
  checkToken: () => {
    let isTokenExist = localStorage.accessToken ? true : false;
    return isTokenExist;
  },
  setToken: (hash) => {
    let normalizedToken = hash.replace(/ /g, '+');
    let decryptedBytes = CryptoJS.AES.decrypt(normalizedToken, config.passphrase);
    let token = decryptedBytes.toString(CryptoJS.enc.Utf8);
    localStorage.accessToken = token;
  },
  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user))
  },
  getUser: () => {
    if (localStorage.user) {
      return JSON.parse(localStorage.user)
    } else {
      return {}
    }
  },
  getToken: () => {
    return localStorage.accessToken;
  },
  encryptToken: (token) => {
    let encryptedToken = CryptoJS.AES.encrypt(token, config.passphrase);
    return encryptedToken;
  },
  redirect: () => {
    let ssoUrl = process.env.VUE_APP_SSO_URL
    localStorage.removeItem('accessToken')
    localStorage.removeItem('user')
    // ssoUrl = `${config.localSsoUrl}?appId=USSE-4` // uncomment for local development
    window.location.href = ssoUrl
  }
}

export default auth;
